// url参数处理

function queryToParm(queryUrl) {
  if (!queryUrl) {
    return {};
  }

  queryUrl = queryUrl.toString();

  const index = queryUrl.indexOf('?');

  if (index == -1) {
    return {};
  }

  queryUrl = queryUrl.slice(index + 1, queryUrl.length);

  const queryList = queryUrl.split('&');

  if (queryList.length == 0) {
    return {};
  }

  let item = null;
  const parm = {};

  for (let i = 0; i < queryList.length; i++) {
    item = queryList[i];
    const ItemList = item.split('=');
    if (ItemList.length > 1) {
      parm[ItemList[0]] = decodeURI(ItemList[1].trim());
    } else {
      parm[ItemList[0]] = '';
    }
  }

  return parm;
}

function parmToQuery(parm) {
  if (!parm) {
    return '';
  }

  let query = '';

  Object.keys(parm).map((key) => {
    query = `${query}${key}=${parm[key]}&`;
    return null;
  });

  query != '' ? (query = query.substr(0, query.length - 1)) : null;

  return query;
}

class QueryUrl {
  constructor(queryUrl) {
    if (!queryUrl) {
      queryUrl = window.location.href;
    }

    this.queryUrl = decodeURIComponent(queryUrl);
    this.origin = this.getOrigin(this.queryUrl);
    this.parm = this.queryToParm(this.queryUrl);
    this.instance = null;
  }

  static getQuery(href, name) {
    const search = href.substr(href.indexOf('?'));
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');

    const r = search.substr(1).match(reg);

    if (r != null) {
      return unescape(r[2]);
    }

    return null;
  }

  static queryToParm(queryUrl) {
    return queryToParm(queryUrl);
  }

  static parmToQuery(parm) {
    return parmToQuery(parm);
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new queryUrl('');
    }
    return this.instance;
  }

  getOrigin(queryUrl) {

    if (!queryUrl) {
      return '';
    }

    queryUrl = queryUrl.toString();

    const index = queryUrl.indexOf('?');

    if (index == -1) {
      return queryUrl;
    }

    return queryUrl.slice(0, index);

  }

  queryToParm(queryUrl) {
    return queryToParm(queryUrl);
  }

  add(parm) {
    Object.keys(parm).map((key) => {
      this.parm[key] = parm[key];
    });
  }

  change(name, value) {
    this.parm[name] = value;
  }

  del(key) {
    delete this.parm[key];
  }

  isEmpty(val) {

    if (val == null) {
      return true;
    }

    if (typeof val == 'undefined') {
      return true;
    }

    val = val.toString().replace(/\s+/g, '');

    if (val == '') {
      return true;
    }

    return false;

  }

  get() {

    let query = '';

    Object.keys(this.parm).map((item) => {
      query = query + item + '=' + this.parm[item] + '&';
      return null;
    });

    if (query == '') {
      return this.origin;
    }

    query = query.slice(0, query.length - 1);
    return this.origin + '?' + query;

  }

  validGet() {

    let query = '';

    Object.keys(this.parm).map((item) => {

      const value = this.parm[item];

      if (this.isEmpty(value) == false) {
        query = query + item + '=' + value + '&';
      }
      return null;
    });

    if (query == '') {
      return this.origin;
    }

    query = query.slice(0, query.length - 1);

    return this.origin + '?' + query;

  }
}

export default QueryUrl;
